import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconDistortion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconDistortion"><Rect x="3.75" y="3.75" width="16.5" height="16.5" rx="3" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 4C17.1962 10.9347 6.80385 13.0653 12 20" stroke="currentColor" strokeWidth="1.5"/><Path d="M4 12C10.9347 6.80385 13.0653 17.1962 20 12" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconDistortion;
